import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { FieldCalibrationStore } from 'stores/FieldCalibrationStore';
import WizardStore from 'stores/WizardStore';
import { AbortModal } from './components/AbortModal/AbortModal';
import { CalibrationConfirmModal } from './components/CalibrationConfirmModal/CalibrationConfirmModal';
import PitchingProgress from './components/PitchingProgress/PitchingProgress';
import { DataCaptureWrapper } from './components/styles/FieldCalibrationStyles';
import { Wizard } from './components/Wizard/Wizard';
import WizardButtonBar from './components/Wizard/WizardButtonBar';
import WizardContent from './components/Wizard/WizardContent';
import WizardSteps from './components/Wizard/WizardSteps';
import Header from './Header';

const FieldCalibration: React.FC = observer(() => {
  const fieldCalibrationStore = useInjection<FieldCalibrationStore>(ServiceTypes.FieldCalibrationStore);
  const wizardStore = useInjection<WizardStore>(ServiceTypes.WizardStore);

  useEffect(() => {
    fieldCalibrationStore.setIsFieldCalibration(true);

    return (): void => {
      fieldCalibrationStore.setIsFieldCalibration(false);
      wizardStore.reset();
    };
  }, []);

  return (
    <DataCaptureWrapper>
      <Header />
      <Wizard />
      {wizardStore.currentStep < WizardSteps.DataCapture && <WizardContent />}
      {wizardStore.currentStep === WizardSteps.DataCapture && <PitchingProgress />}
      <WizardButtonBar />
      <AbortModal />
      <CalibrationConfirmModal />
    </DataCaptureWrapper>
  );
});

export default FieldCalibration;
